import React from 'react'

// Editorial color palette for previews
const c = {
  rose: '#C9A9A6',
  blush: '#E8D5D0',
  sage: '#8B9E8B',
  cream: '#F5EDE3',
  terra: '#C17F59',
  navy: '#2C3E50',
  sand: '#D4C5B2',
  plum: '#7B5B6E',
  olive: '#A3A87C',
  slate: '#64748B'
}

// Basic layout blocks for the email builder
export const basicLayouts = [
  {
    id: 'hero-editorial-type',
    name: 'Editorial Hero',
    category: 'hero',
    description: 'Large display type on a solid colour',
    preview: (
      <div style={{ height: '72px', backgroundColor: c.cream, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
        <div style={{ fontSize: '5px', fontWeight: '600', color: c.terra, letterSpacing: '0.18em' }}>EYEBROW</div>
        <div style={{ fontSize: '15px', fontFamily: 'Georgia, serif', color: c.navy, lineHeight: 1 }}>Headline</div>
        <div style={{ height: '2px', backgroundColor: c.sand, width: '45%', borderRadius: '1px', marginTop: '2px' }} />
      </div>
    ),
    blocks: [
      { type: 'layout-editorial-hero', content: { eyebrow: 'A note from us', headline: 'A headline that sets the tone', subtext: 'A line of supporting copy to set the scene.', backgroundColor: '#F5EDE3', textColor: '#2C3E50', accentColor: '#C17F59', headlineFontFamily: 'Georgia, serif', headlineSize: 44 }}
    ]
  },
  {
    id: 'utility-bar',
    name: 'Utility Bar',
    category: 'hero',
    description: 'Tiny caps strip, left and right text',
    preview: (
      <div style={{ height: '72px', display: 'flex', alignItems: 'center' }}>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', padding: '0 10px', borderTop: '1px solid #eee', borderBottom: '1px solid #eee', height: '22px', alignItems: 'center' }}>
          <span style={{ fontSize: '5px', fontWeight: '600', color: c.navy, letterSpacing: '0.16em' }}>LEFT TEXT</span>
          <span style={{ fontSize: '5px', fontWeight: '600', color: c.navy, letterSpacing: '0.16em' }}>RIGHT TEXT</span>
        </div>
      </div>
    ),
    blocks: [
      { type: 'layout-utility-bar', content: { leftText: 'Your salon', rightText: 'Est. 2026', textColor: '#1a1a1a', backgroundColor: '#ffffff', showRule: true }}
    ]
  },
  {
    id: 'hero-arch',
    name: 'Arch Hero',
    category: 'hero',
    description: 'Rounded bottom image header',
    preview: (
      <div style={{ height: '72px', backgroundColor: c.rose, position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.45), transparent 70%)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', paddingBottom: '20px', gap: '3px' }}>
          <div style={{ height: '5px', backgroundColor: 'white', width: '45%', borderRadius: '2px' }} />
          <div style={{ height: '3px', backgroundColor: 'rgba(255,255,255,0.6)', width: '30%', borderRadius: '2px' }} />
        </div>
        <div style={{ position: 'absolute', bottom: '-38%', left: '-10%', right: '-10%', height: '48%', backgroundColor: 'white', borderRadius: '100% 100% 0 0' }} />
      </div>
    ),
    blocks: [
      { type: 'layout-arch', content: { headline: 'Welcome', subtext: 'We\'re glad you\'re here', imageUrl: '', textColor: '#ffffff' }}
    ]
  },
  {
    id: 'hero-gradient',
    name: 'Gradient Hero',
    category: 'hero',
    description: 'Bold gradient with text overlay',
    preview: (
      <div style={{ height: '72px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
        <div style={{ height: '7px', backgroundColor: 'white', width: '55%', borderRadius: '2px' }} />
        <div style={{ height: '3px', backgroundColor: 'rgba(255,255,255,0.55)', width: '38%', borderRadius: '2px' }} />
      </div>
    ),
    blocks: [
      { type: 'layout-gradient', content: { headline: 'Big Announcement', subtext: 'Something exciting is here', gradient: 'purple', textColor: '#ffffff' }}
    ]
  },
  {
    id: 'hero-editorial',
    name: 'Editorial',
    category: 'hero',
    description: 'Image left, text right layout',
    preview: (
      <div style={{ display: 'flex', height: '72px', overflow: 'hidden' }}>
        <div style={{ flex: 1, backgroundColor: c.sage }} />
        <div style={{ flex: 1, backgroundColor: c.cream, display: 'flex', flexDirection: 'column', gap: '4px', justifyContent: 'center', padding: '0 10px' }}>
          <div style={{ height: '6px', backgroundColor: c.navy, width: '75%', borderRadius: '2px' }} />
          <div style={{ height: '3px', backgroundColor: c.sand, width: '95%', borderRadius: '1px' }} />
          <div style={{ height: '3px', backgroundColor: c.sand, width: '65%', borderRadius: '1px' }} />
        </div>
      </div>
    ),
    blocks: [
      { type: 'layout-editorial', content: { headline: 'Feature Story', body: 'Add your compelling story here...', imageUrl: '', textColor: '#1a1a1a' }}
    ]
  },
  {
    id: 'hero-polaroid',
    name: 'Polaroid',
    category: 'hero',
    description: 'Photo with caption below',
    preview: (
      <div style={{ height: '72px', backgroundColor: c.cream, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: '48px', padding: '3px 3px 8px', backgroundColor: 'white', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', transform: 'rotate(-3deg)' }}>
          <div style={{ height: '38px', backgroundColor: c.rose, marginBottom: '4px' }} />
          <div style={{ height: '2px', backgroundColor: c.sand, width: '55%', margin: '0 auto', borderRadius: '1px' }} />
        </div>
      </div>
    ),
    blocks: [
      { type: 'layout-polaroid', content: { caption: 'Your caption here', imageUrl: '', backgroundColor: '#ffffff' }}
    ]
  },
  {
    id: 'hero-full-bleed',
    name: 'Full Bleed',
    category: 'hero',
    description: 'Edge-to-edge image with overlay text',
    preview: (
      <div style={{ height: '72px', backgroundColor: c.navy, position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, rgba(44,62,80,0.85), rgba(44,62,80,0.6))' }} />
        <div style={{ height: '7px', backgroundColor: 'white', width: '55%', borderRadius: '2px', zIndex: 1 }} />
        <div style={{ height: '3px', backgroundColor: 'rgba(255,255,255,0.5)', width: '35%', borderRadius: '2px', zIndex: 1 }} />
      </div>
    ),
    blocks: [
      { type: 'layout-full-bleed', content: { headline: 'Bold Statement', subtext: 'Supporting message', imageUrl: '', overlayOpacity: 40 }}
    ]
  },
  {
    id: 'hero-split',
    name: 'Split Hero',
    category: 'hero',
    description: 'Half image, half content',
    preview: (
      <div style={{ display: 'flex', height: '72px', overflow: 'hidden' }}>
        <div style={{ flex: 1, backgroundColor: c.terra }} />
        <div style={{ flex: 1, backgroundColor: 'white', display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0 10px', gap: '4px' }}>
          <div style={{ height: '6px', backgroundColor: c.navy, width: '70%', borderRadius: '2px' }} />
          <div style={{ height: '3px', backgroundColor: '#d1d5db', width: '90%', borderRadius: '1px' }} />
          <div style={{ height: '3px', backgroundColor: '#d1d5db', width: '55%', borderRadius: '1px' }} />
        </div>
      </div>
    ),
    blocks: [
      { type: 'layout-hero-split', content: { headline: 'Feature Title', body: 'Description text', imageUrl: '', imagePosition: 'left' }}
    ]
  },
  {
    id: 'duo-grid',
    name: 'Duo Grid',
    category: 'gallery',
    description: 'Two image cards with captions',
    preview: (
      <div style={{ height: '72px', backgroundColor: c.cream, display: 'flex', gap: '5px', padding: '8px 10px' }}>
        {[c.rose, c.sage].map((bg, i) => (
          <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '3px' }}>
            <div style={{ flex: 1, backgroundColor: bg, borderRadius: '4px' }} />
            <div style={{ height: '3px', backgroundColor: c.navy, width: '55%', borderRadius: '1px' }} />
            <div style={{ height: '2px', backgroundColor: c.sand, width: '80%', borderRadius: '1px' }} />
          </div>
        ))}
      </div>
    ),
    blocks: [
      { type: 'layout-duo-grid', content: { leftImage: '', leftTitle: 'First story', leftCaption: 'A short supporting line.', rightImage: '', rightTitle: 'Second story', rightCaption: 'A short supporting line.', backgroundColor: '#F5EDE3', textColor: '#2C3E50' }}
    ]
  },
  {
    id: 'bento-2col',
    name: 'Bento 2-Col',
    category: 'gallery',
    description: 'Asymmetric 2-column grid',
    preview: (
      <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr', gridTemplateRows: '1fr 1fr', gap: '3px', height: '72px', padding: '4px' }}>
        <div style={{ gridRow: '1 / 3', backgroundColor: c.sage, borderRadius: '4px' }} />
        <div style={{ backgroundColor: c.blush, borderRadius: '4px' }} />
        <div style={{ backgroundColor: c.sand, borderRadius: '4px' }} />
      </div>
    ),
    blocks: [
      { type: 'layout-bento-2col', content: {
        mainImage: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=600',
        topImage: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400',
        bottomImage: 'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=400',
        mainText: ''
      }}
    ]
  },
  {
    id: 'bento-3col',
    name: 'Bento Grid',
    category: 'gallery',
    description: '4-image masonry layout',
    preview: (
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gridTemplateRows: '1fr 1fr', gap: '3px', height: '72px', padding: '4px' }}>
        <div style={{ gridRow: 'span 2', backgroundColor: c.terra, borderRadius: '4px' }} />
        <div style={{ gridColumn: 'span 2', backgroundColor: c.sage, borderRadius: '4px' }} />
        <div style={{ backgroundColor: c.blush, borderRadius: '4px' }} />
        <div style={{ backgroundColor: c.olive, borderRadius: '4px' }} />
      </div>
    ),
    blocks: [
      { type: 'layout-bento-3col', content: { images: [
        'https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?w=400',
        'https://images.unsplash.com/photo-1522337094846-8a818192de1f?w=400',
        'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=400',
        'https://images.unsplash.com/photo-1580618672591-eb180b1a973f?w=400'
      ] }}
    ]
  },
  {
    id: 'section-intro',
    name: 'Section Intro',
    category: 'content',
    description: 'Eyebrow, heading, and lead-in text',
    preview: (
      <div style={{ height: '72px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
        <div style={{ fontSize: '5px', fontWeight: '600', color: c.slate, letterSpacing: '0.18em' }}>EYEBROW</div>
        <div style={{ fontSize: '11px', fontFamily: 'Georgia, serif', color: c.navy }}>Section heading</div>
        <div style={{ height: '2px', backgroundColor: '#d1d5db', width: '60%', borderRadius: '1px' }} />
        <div style={{ height: '2px', backgroundColor: '#d1d5db', width: '40%', borderRadius: '1px' }} />
      </div>
    ),
    blocks: [
      { type: 'layout-section-intro', content: { eyebrow: 'The details', heading: 'A heading for this section', body: 'A short introduction for the content that follows.', textColor: '#1a1a1a', accentColor: '#9ca3af' }}
    ]
  },
  {
    id: 'feature-card',
    name: 'Feature Card',
    category: 'content',
    description: 'Image + title + description card',
    preview: (
      <div style={{ height: '72px', display: 'flex', justifyContent: 'center', padding: '4px 16px' }}>
        <div style={{ width: '100%', maxWidth: '140px', backgroundColor: 'white', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
          <div style={{ height: '36px', backgroundColor: c.rose }} />
          <div style={{ padding: '5px 8px', display: 'flex', flexDirection: 'column', gap: '3px' }}>
            <div style={{ height: '5px', backgroundColor: c.navy, width: '70%', borderRadius: '2px' }} />
            <div style={{ height: '2px', backgroundColor: '#d1d5db', width: '90%', borderRadius: '1px' }} />
          </div>
        </div>
      </div>
    ),
    blocks: [
      { type: 'layout-feature-card', content: { headline: 'Feature Title', body: 'Description text', imageUrl: '', cornerRadius: 16 }}
    ]
  },
  {
    id: 'glass-card',
    name: 'Glass Card',
    category: 'content',
    description: 'Glassmorphism effect card',
    preview: (
      <div style={{ height: '72px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: '60%', background: 'rgba(255,255,255,0.18)', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.28)', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
          <div style={{ height: '5px', backgroundColor: 'white', width: '65%', borderRadius: '2px' }} />
          <div style={{ height: '3px', backgroundColor: 'rgba(255,255,255,0.5)', width: '80%', borderRadius: '1px' }} />
        </div>
      </div>
    ),
    blocks: [
      { type: 'layout-glass-card', content: { headline: 'Elegant Title', body: 'Description', gradient: 'purple' }}
    ]
  },
  {
    id: 'stats-row',
    name: 'Stats Row',
    category: 'content',
    description: 'Highlight 3 key numbers',
    preview: (
      <div style={{ display: 'flex', gap: '4px', height: '72px', padding: '10px 6px', alignItems: 'center' }}>
        {[{ v: '500+', l: 'clients' }, { v: '15', l: 'years' }, { v: '4.9', l: 'rating' }].map((s, i) => (
          <div key={i} style={{ flex: 1, textAlign: 'center' }}>
            <div style={{ fontSize: '16px', fontWeight: '800', color: '#007EA0', lineHeight: 1, letterSpacing: '-0.03em' }}>{s.v}</div>
            <div style={{ fontSize: '6px', color: c.slate, marginTop: '3px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.03em' }}>{s.l}</div>
          </div>
        ))}
      </div>
    ),
    blocks: [
      { type: 'layout-stats', content: { stats: [{ value: '500+', label: 'Happy Clients' }, { value: '15', label: 'Years' }, { value: '4.9', label: 'Rating' }] }}
    ]
  },
  {
    id: 'shape-image',
    name: 'Shape Crop',
    category: 'image',
    description: 'Photo cropped into an arch, flower, heart, and more',
    preview: (
      <div style={{ height: '72px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', backgroundColor: c.cream }}>
        <div style={{ width: '30px', height: '38px', backgroundColor: c.terra, borderRadius: '15px 15px 0 0' }} />
        <svg width="36" height="36" viewBox="0 0 100 100">
          <path d="M 50 91 C 18 66 4 48 4 30 C 4 14 17 4 30 4 C 39 4 46 9 50 16 C 54 9 61 4 70 4 C 83 4 96 14 96 30 C 96 48 82 66 50 91 Z" fill={c.rose} />
        </svg>
        <div style={{ width: '34px', height: '34px', backgroundColor: c.sage, borderRadius: '50%' }} />
      </div>
    ),
    blocks: [
      { type: 'layout-shape-image', content: { shape: 'arch', imageUrl: '', frameColor: '', width: 78, backgroundColor: '#F5EDE3' }}
    ]
  },
  {
    id: 'quote-chips',
    name: 'Quote Chips',
    category: 'content',
    description: 'Short client quotes in playful chips',
    preview: (
      <div style={{ height: '72px', backgroundColor: c.cream, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px', padding: '10px' }}>
        {['"so good"', '"love it"', '"the best"', '"again!"'].map((q, i) => (
          <div key={i} style={{ backgroundColor: '#fff', borderRadius: '7px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '6px', fontWeight: '600', color: c.navy }}>{q}</div>
        ))}
      </div>
    ),
    blocks: [
      { type: 'layout-quote-chips', content: { q1: '"so good"', q2: '"love this place"', q3: '"my happy hour"', q4: '"booked again already"', chipColor: '#ffffff', textColor: '#1a1a1a', backgroundColor: '#F5EDE3' }}
    ]
  },
  {
    id: 'rounded-image',
    name: 'Rounded Image',
    category: 'image',
    description: 'Single image with rounded corners',
    preview: (
      <div style={{ height: '72px', padding: '8px 12px' }}>
        <div style={{ width: '100%', height: '100%', backgroundColor: c.sage, borderRadius: '14px' }} />
      </div>
    ),
    blocks: [
      { type: 'layout-rounded-image', content: { imageUrl: '', cornerRadius: 24 }}
    ]
  },
  {
    id: 'before-after',
    name: 'Before/After',
    category: 'image',
    description: 'Side-by-side comparison',
    preview: (
      <div style={{ display: 'flex', gap: '4px', height: '72px', padding: '6px' }}>
        <div style={{ flex: 1, backgroundColor: c.blush, borderRadius: '6px', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', paddingBottom: '5px' }}>
          <span style={{ fontSize: '7px', fontWeight: '700', color: c.plum, letterSpacing: '0.03em' }}>BEFORE</span>
        </div>
        <div style={{ flex: 1, backgroundColor: c.sage, borderRadius: '6px', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', paddingBottom: '5px' }}>
          <span style={{ fontSize: '7px', fontWeight: '700', color: '#2d4a2d', letterSpacing: '0.03em' }}>AFTER</span>
        </div>
      </div>
    ),
    blocks: [
      { type: 'layout-before-after', content: { beforeImage: '', afterImage: '', beforeLabel: 'Before', afterLabel: 'After' }}
    ]
  },
  {
    id: 'testimonial',
    name: 'Testimonial',
    category: 'content',
    description: 'Quote with avatar',
    preview: (
      <div style={{ height: '72px', backgroundColor: c.cream, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '2px', padding: '6px' }}>
        <span style={{ fontSize: '22px', lineHeight: 1, color: c.rose, fontFamily: 'Georgia, serif', marginBottom: '1px' }}>"</span>
        <div style={{ height: '2px', backgroundColor: c.sand, width: '70%', borderRadius: '1px' }} />
        <div style={{ height: '2px', backgroundColor: c.sand, width: '50%', borderRadius: '1px' }} />
        <div style={{ width: '14px', height: '14px', borderRadius: '50%', backgroundColor: c.rose, marginTop: '3px' }} />
      </div>
    ),
    blocks: [
      { type: 'layout-testimonial', content: { quote: 'Amazing experience!', name: 'Client Name', title: 'Regular Client', avatarUrl: '' }}
    ]
  },
  {
    id: 'cta-gradient',
    name: 'CTA Banner',
    category: 'cta',
    description: 'Gradient background with button',
    preview: (
      <div style={{ height: '72px', background: 'linear-gradient(135deg, #007EA0, #059669)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '7px' }}>
        <div style={{ height: '6px', backgroundColor: 'white', width: '45%', borderRadius: '2px' }} />
        <div style={{ height: '14px', width: '30%', backgroundColor: 'white', borderRadius: '4px' }} />
      </div>
    ),
    blocks: [
      { type: 'layout-cta-gradient', content: { headline: 'Ready to Book?', buttonText: 'Book Now', buttonUrl: '{{BookingLink}}', background: 'linear-gradient(135deg, #007EA0, #059669)' }}
    ]
  },
  {
    id: 'promo-banner',
    name: 'Promo Banner',
    category: 'cta',
    description: 'Eye-catching promotional strip',
    preview: (
      <div style={{ height: '72px', backgroundColor: '#fbbf24', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '3px' }}>
        <span style={{ fontSize: '16px', fontWeight: '800', color: '#1a1a1a', letterSpacing: '0.04em' }}>20% OFF</span>
        <div style={{ height: '3px', backgroundColor: 'rgba(0,0,0,0.15)', width: '40%', borderRadius: '1px' }} />
      </div>
    ),
    blocks: [
      { type: 'layout-promo-banner', content: { promoText: '20% OFF', subtext: 'Use code SAVE20', backgroundColor: '#fbbf24' }}
    ]
  },
  {
    id: 'price-card',
    name: 'Price Card',
    category: 'content',
    description: 'Service with pricing',
    preview: (
      <div style={{ height: '72px', padding: '6px 8px' }}>
        <div style={{ height: '100%', backgroundColor: c.cream, borderRadius: '6px', borderLeft: '3px solid #007EA0', padding: '8px 10px', display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '4px' }}>
          <div style={{ height: '5px', backgroundColor: c.navy, width: '55%', borderRadius: '2px' }} />
          <div style={{ height: '2px', backgroundColor: c.sand, width: '75%', borderRadius: '1px' }} />
          <div style={{ display: 'flex', gap: '6px', alignItems: 'center', marginTop: '1px' }}>
            <span style={{ fontSize: '7px', color: c.sand, textDecoration: 'line-through' }}>£129</span>
            <span style={{ fontSize: '12px', fontWeight: '800', color: '#059669' }}>£99</span>
          </div>
        </div>
      </div>
    ),
    blocks: [
      { type: 'layout-price-card', content: { serviceName: 'Service Name', description: 'Service description', originalPrice: '129', salePrice: '99' }}
    ]
  },
  {
    id: 'badge-highlight',
    name: 'Badge Highlight',
    category: 'content',
    description: 'Attention-grabbing badge',
    preview: (
      <div style={{ height: '72px', backgroundColor: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
        <div style={{ padding: '2px 10px', backgroundColor: '#ef4444', borderRadius: '100px' }}>
          <span style={{ fontSize: '7px', fontWeight: '700', color: 'white', textTransform: 'uppercase', letterSpacing: '0.06em' }}>NEW</span>
        </div>
        <div style={{ height: '7px', backgroundColor: c.navy, width: '50%', borderRadius: '2px' }} />
        <div style={{ height: '3px', backgroundColor: '#d1d5db', width: '35%', borderRadius: '1px' }} />
      </div>
    ),
    blocks: [
      { type: 'layout-badge', content: { badgeText: 'NEW', headline: 'Something exciting', body: 'A short supporting line to build the moment.' }}
    ]
  },
  {
    id: 'countdown',
    name: 'Countdown',
    category: 'cta',
    description: 'Urgency timer display',
    preview: (
      <div style={{ height: '72px', backgroundColor: '#1a1a1a', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
        <div style={{ height: '3px', backgroundColor: 'rgba(255,255,255,0.5)', width: '32%', borderRadius: '1px' }} />
        <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
          {['02', '14', '30', '00'].map((v, i) => (
            <React.Fragment key={i}>
              {i > 0 && <span style={{ color: 'rgba(255,255,255,0.25)', fontSize: '10px', fontWeight: '700' }}>:</span>}
              <div style={{ width: '18px', height: '22px', backgroundColor: 'rgba(255,255,255,0.1)', borderRadius: '3px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontSize: '9px', fontWeight: '800', color: 'white' }}>{v}</span>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    ),
    blocks: [
      { type: 'layout-countdown', content: { headline: 'Offer Ends In', days: '02', hours: '14', mins: '30', secs: '00' }}
    ]
  },
  {
    id: 'fancy-divider',
    name: 'Fancy Divider',
    category: 'divider',
    description: 'Decorative line with dots',
    preview: (
      <div style={{ height: '48px', display: 'flex', alignItems: 'center', gap: '6px', padding: '0 12px' }}>
        <div style={{ flex: 1, height: '1px', backgroundColor: '#e5e5e5' }} />
        {[1,2,3].map(i => (
          <div key={i} style={{ width: '5px', height: '5px', borderRadius: '50%', backgroundColor: '#007EA0' }} />
        ))}
        <div style={{ flex: 1, height: '1px', backgroundColor: '#e5e5e5' }} />
      </div>
    ),
    blocks: [
      { type: 'layout-fancy-divider', content: { color: '#007EA0' }}
    ]
  },
  {
    id: 'wave-divider',
    name: 'Wave Divider',
    category: 'divider',
    description: 'Curved section transition',
    preview: (
      <div style={{ height: '48px', position: 'relative', overflow: 'hidden' }}>
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" style={{ position: 'absolute', bottom: 0, width: '100%', height: '30px' }}>
          <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" fill={c.cream} />
        </svg>
      </div>
    ),
    blocks: [
      { type: 'layout-wave-divider', content: { color: '#F5EDE3', position: 'bottom' }}
    ]
  },
  {
    id: 'social-strip',
    name: 'Social Strip',
    category: 'social',
    description: 'Social media icons in a row',
    preview: (
      <div style={{ height: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '7px' }}>
        {[1,2,3,4].map(i => (
          <div key={i} style={{ width: '20px', height: '20px', backgroundColor: c.navy, borderRadius: '5px' }} />
        ))}
      </div>
    ),
    blocks: [
      { type: 'layout-social-strip', content: { facebook: '', instagram: '', twitter: '', tiktok: '', style: 'rounded' }}
    ]
  },
  {
    id: 'contact-card',
    name: 'Contact Card',
    category: 'social',
    description: 'Address, phone, and hours',
    preview: (
      <div style={{ height: '72px', padding: '6px 8px' }}>
        <div style={{ height: '100%', backgroundColor: c.cream, borderRadius: '6px', padding: '8px 10px', display: 'flex', flexDirection: 'column', gap: '5px', justifyContent: 'center' }}>
          {[{ w: '65%' }, { w: '50%' }, { w: '70%' }].map((r, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <div style={{ width: '7px', height: '7px', borderRadius: '50%', backgroundColor: c.sage, flexShrink: 0 }} />
              <div style={{ height: '3px', backgroundColor: c.sand, width: r.w, borderRadius: '1px' }} />
            </div>
          ))}
        </div>
      </div>
    ),
    blocks: [
      { type: 'layout-contact-card', content: { address: '', phone: '', hours: '', email: '' }}
    ]
  }
]

// Content-based layouts that need picker selection
export const contentLayouts = [
  {
    id: 'review-card',
    name: 'Client Review',
    category: 'content',
    description: 'Feature a real review from your clients',
    pickerType: 'review',
    preview: (
      <div style={{ height: '72px', backgroundColor: c.cream, borderRadius: '4px', padding: '8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '3px' }}>
        <div style={{ display: 'flex', gap: '2px', marginBottom: '2px' }}>
          {[1,2,3,4,5].map(i => (
            <div key={i} style={{ width: '7px', height: '7px', backgroundColor: '#f59e0b', borderRadius: '1px' }} />
          ))}
        </div>
        <div style={{ height: '2px', backgroundColor: c.sand, width: '75%', borderRadius: '1px' }} />
        <div style={{ height: '2px', backgroundColor: c.sand, width: '55%', borderRadius: '1px' }} />
        <div style={{ height: '4px', backgroundColor: c.navy, width: '35%', borderRadius: '2px', marginTop: '2px' }} />
      </div>
    )
  },
  {
    id: 'service-spotlight',
    name: 'Service Spotlight',
    category: 'content',
    description: 'Showcase a service from your menu',
    pickerType: 'service',
    preview: (
      <div style={{ display: 'flex', gap: '6px', height: '72px', padding: '6px' }}>
        <div style={{ width: '38%', backgroundColor: c.terra, borderRadius: '5px' }} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '4px', justifyContent: 'center' }}>
          <div style={{ height: '5px', backgroundColor: c.navy, width: '70%', borderRadius: '2px' }} />
          <div style={{ height: '2px', backgroundColor: c.sand, width: '95%', borderRadius: '1px' }} />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '2px' }}>
            <span style={{ fontSize: '11px', fontWeight: '800', color: '#007EA0' }}>£45</span>
            <div style={{ height: '2px', backgroundColor: c.sand, width: '30%', borderRadius: '1px' }} />
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'team-spotlight',
    name: 'Team Spotlight',
    category: 'content',
    description: 'Feature a team member',
    pickerType: 'team',
    preview: (
      <div style={{ height: '72px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '3px' }}>
        <div style={{ width: '26px', height: '26px', borderRadius: '50%', background: 'linear-gradient(135deg, #007EA0, #059669)', padding: '2px' }}>
          <div style={{ width: '100%', height: '100%', borderRadius: '50%', backgroundColor: c.rose, border: '1.5px solid white' }} />
        </div>
        <div style={{ height: '4px', backgroundColor: c.navy, width: '35%', borderRadius: '2px' }} />
        <div style={{ height: '2px', backgroundColor: '#007EA0', width: '25%', borderRadius: '1px' }} />
      </div>
    )
  }
]

// Block type palette categories
export const blockTypeCategories = [
  { type: 'text', label: 'Text', icon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M4 7V4h16v3"/><path d="M9 20h6"/><path d="M12 4v16"/>
    </svg>
  )},
  { type: 'image', label: 'Image', icon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
      <circle cx="8.5" cy="8.5" r="1.5"/>
      <polyline points="21 15 16 10 5 21"/>
    </svg>
  )},
  { type: 'button', label: 'Button', icon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="3" y="8" width="18" height="8" rx="2"/>
      <path d="M8 12h8"/>
    </svg>
  )},
  { type: 'divider', label: 'Divider', icon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <line x1="3" y1="12" x2="21" y2="12"/>
    </svg>
  )},
  { type: 'spacer', label: 'Spacer', icon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M12 5v14M5 12h14"/>
    </svg>
  )},
  { type: 'columns', label: 'Columns', icon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="3" y="3" width="7" height="18" rx="1"/>
      <rect x="14" y="3" width="7" height="18" rx="1"/>
    </svg>
  )},
  { type: 'logo', label: 'Logo', icon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="3" y="3" width="18" height="18" rx="2"/>
      <path d="M12 8v8M8 12h8"/>
    </svg>
  )},
  { type: 'layout', label: 'Layouts', icon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="3" y="3" width="18" height="7" rx="1"/>
      <rect x="3" y="14" width="8" height="7" rx="1"/>
      <rect x="13" y="14" width="8" height="7" rx="1"/>
    </svg>
  )},
  { type: 'review', label: 'Review', icon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  )},
  { type: 'service', label: 'Service', icon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
    </svg>
  )},
  { type: 'team', label: 'Team', icon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>
  )}
]
